import { Card, Typography } from 'antd';

const ProfileTypes = () => {
  const data = [
    {
      title: 'Produtor',
      description: 'Você cria e faz a gestão dos seus próprios produtos.'
    },
    {
      title: 'Agência',
      description: 'Gerencia os produtos de uma carteira de clientes.'
    },
    {
      title: 'Afiliado',
      description: 'Você divulga produtos de outros criadores e ganha comissão por cada venda realizada.'
    },
    {
      title: 'Co-produtor',
      description: 'Atua junto ao produtor na criação e gestão do produto, compartilhando responsabilidades.'
    },
    {
      title: 'Lançador',
      description: 'Especialista em estratégias de lançamento que impulsionam vendas.'
    },
    {
      description:
        'Eu já tenho uma certa experiência em vendas online e estou na fase de escalar meus produtos e negócio.'
    }
  ];

  return (
    <div className='bg-surface-subtle border-outline-disabled rounded-default mt-4 flex w-100 flex-col items-center justify-center gap-2 border p-4'>
      {data.map((item, index) => (
        <Card
          key={index}
          size='small'
          className='bg-default-product border-outline-default rounded-default w-full'
          classNames={{ body: 'p-4' }}
        >
          <Card.Meta
            title={
              item?.title ? (
                <Typography.Title level={5} className='mb-0'>
                  {item.title}
                </Typography.Title>
              ) : undefined
            }
            description={
              <span className={item?.title ? 'text-content-body' : 'text-content-title'}>{item.description}</span>
            }
          />
        </Card>
      ))}
    </div>
  );
};

export default ProfileTypes;
